import * as React from "react";
import { Segment, Placeholder } from "semantic-ui-react";
import "./SectionSkeleton.css";

const SectionSkeleton: React.FC = () => {
    return (
        <Segment className="section-skeleton">
            <Placeholder fluid={true}>
                <Placeholder.Header image={true}>
                    <Placeholder.Line length="very long" />
                    <Placeholder.Line length="long" />
                </Placeholder.Header>
                <Placeholder.Paragraph>
                    <Placeholder.Line length="full" />
                    <Placeholder.Line length="full" />
                    <Placeholder.Line length="full" />
                </Placeholder.Paragraph>
            </Placeholder>
        </Segment>
    );
};

export default SectionSkeleton;
